module.exports = __webpack_public_path__ + "img/nsma-logo.c7609a33.png";